import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enCommon from '@/locales/en/common.json';
import trCommon from '@/locales/tr/common.json';
import deCommon from '@/locales/de/common.json';
import elCommon from '@/locales/el/common.json';
import frCommon from '@/locales/fr/common.json';
// Herkese açık modül sayfalarının (/platform/*) uzun pazarlama metinleri ayrı dosyada; "modulePages" anahtarı altında
// aynı translation kataloğuna eklenir.
import enModulePages from '@/locales/en/modulePages.json';
import trModulePages from '@/locales/tr/modulePages.json';
import deModulePages from '@/locales/de/modulePages.json';
import elModulePages from '@/locales/el/modulePages.json';
import frModulePages from '@/locales/fr/modulePages.json';
import {
  CRAWLER_LANGUAGE_DETECTION_ORDER,
  CRAWLER_USER_AGENT_PATTERN,
  LANGUAGE_QUERY_PARAM,
  USER_LANGUAGE_DETECTION_ORDER,
} from '@/constants/i18nDetection';
const resources = {
  en: {
    translation: { ...enCommon, modulePages: enModulePages },
  },
  tr: {
    translation: { ...trCommon, modulePages: trModulePages },
  },
  de: {
    translation: { ...deCommon, modulePages: deModulePages },
  },
  el: {
    translation: { ...elCommon, modulePages: elModulePages },
  },
  fr: {
    translation: { ...frCommon, modulePages: frModulePages },
  },
};
const isCrawler = typeof navigator !== 'undefined' && CRAWLER_USER_AGENT_PATTERN.test(navigator.userAgent);
// The page's language follows the one shown, so the browser applies that language's rules
// (e.g. upper-casing an English "i" as "I", not the Turkish "İ").
const syncDocumentLanguage = (language: string) => {
  if (typeof document !== 'undefined' && language) document.documentElement.lang = language.split('-')[0];
};
if (!i18n.isInitialized) {
  i18n.on('languageChanged', syncDocumentLanguage);
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'tr',
      supportedLngs: ['en', 'tr', 'de', 'el', 'fr'],
      load: 'languageOnly',
      keySeparator: '.',
      nsSeparator: ':',
      detection: {
        order: isCrawler ? CRAWLER_LANGUAGE_DETECTION_ORDER : USER_LANGUAGE_DETECTION_ORDER,
        caches: isCrawler ? [] : ['localStorage'],
        lookupQuerystring: LANGUAGE_QUERY_PARAM,
        lookupLocalStorage: 'i18nextLng',
      },
      interpolation: {
        escapeValue: false,
      },
      returnNull: false,
      returnEmptyString: false,
    });
}
export default i18n;
